<app-error [title]="title" [description]="description | translate" [isFullPage]="true"></app-error>